/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GetBillingScheduleTiersOutputJsonApiModel = {
  id: "",
  "billing-schedule-tiers": {
    jsonApi: "hasMany",
    type: "billing-schedule-tiers",
  },
  calculated: "",
};
